"use client";

import * as React from "react";
import { X } from "lucide-react";
import { Chip } from "./Chip";

interface FilterTagProps {
  value: string;
  onRemove: () => void;
  icon?: React.ComponentType<{ className?: string }>;
  disabled?: boolean;
}

export function FilterTag({ value, onRemove, icon: Icon, disabled }: FilterTagProps) {
  return (
    <Chip variant="neutral" className="inline-flex items-center gap-1 px-2 text-caption normal-case">
      {Icon && <Icon className="h-2.5 w-2.5 shrink-0 text-muted-foreground" />}
      {value}
      <button
        type="button"
        aria-label={`Remove ${value}`}
        disabled={disabled}
        onClick={onRemove}
        className="ml-0.5 cursor-pointer text-muted-foreground hover:text-foreground disabled:cursor-not-allowed disabled:opacity-50"
      >
        <X className="h-2.5 w-2.5" />
      </button>
    </Chip>
  );
}
